import React from 'react';
import { GlobalContext } from '../../store/GlobalContext';
import Modal from './Modal';

const ModalConfirmacao = () => {
  const { modalData, setModalData } = React.useContext(GlobalContext);
  if (modalData === null) {
    return null;
  }

  return (
    <Modal
      titulo={modalData.titulo}
      aberto={modalData.visible === true}
      setAberto={() => setModalData({ visible: false })}
    >
      <img
        alt="imagem de perfil da carol, assistente virtual dos correios"
        id="img-carol-boasvindas"
        src="/images/carol-perfil.png"
      />
      <br />
      <p>{modalData.texto}</p>
      <br />
      <div className="botoes">
        <button
          className="basico btnPesquisa btn-txt"
          onClick={(ev) => {
            modalData.acaoConfirmacao();
            setModalData({ visible: false });
          }}
        >
          Sim
        </button>
        <button
          className="btnCancela btn-txt"
          onClick={(ev) => setModalData({ visible: false })}
        >
          Não
        </button>
      </div>
    </Modal>
  );
};

export default ModalConfirmacao;
